const API_BASE = (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
const INVALID_SESSION_STATUSES = new Set([401, 403, 404, 410]);

export function isInvalidSessionError(error) {
    return INVALID_SESSION_STATUSES.has(Number(error?.status));
}

function buildHeaders(auth, extraHeaders = {}) {
    const headers = {
        "Content-Type": "application/json",
        ...extraHeaders,
    };

    if (auth?.token) {
        headers.Authorization = `Bearer ${auth.token}`;
    }

    if (!auth?.token && auth?.telegramInitData) {
        headers["X-Telegram-Init-Data"] = auth.telegramInitData;
    }

    return headers;
}

export async function apiPost(path, body = {}, auth, extraOptions = {}) {
    const response = await fetch(`${API_BASE}${path}`, {
        method: "POST",
        headers: buildHeaders(auth, extraOptions.headers),
        body: JSON.stringify(body),
        ...extraOptions,
    });

    if (!response.ok) {
        const errorText = await response.text();
        const error = new Error(errorText || "Request failed");
        error.status = response.status;
        throw error;
    }

    return response.json();
}

export async function apiGet(path, auth, extraOptions = {}) {
    const response = await fetch(`${API_BASE}${path}`, {
        method: "GET",
        headers: buildHeaders(auth, extraOptions.headers),
        ...extraOptions,
    });

    if (!response.ok) {
        const errorText = await response.text();
        const error = new Error(errorText || "Request failed");
        error.status = response.status;
        throw error;
    }

    return response.json();
}

export async function apiDebugLog(event, payload = {}) {
    try {
        await fetch(`${API_BASE}/cabinet/debug/front-log`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                event,
                payload,
            }),
        });
    } catch {
        // Ignore debug transport failures.
    }
}

export { API_BASE };
